export default __webpack_public_path__ + "static/media/call-center.605c5dcd.jpg";